import getIn from '@alexaivars/get-in';
import qs from 'lib/normalizingQs';
import { SITES } from 'lib/constants';
import { NAME } from '../constants';
import { combineReducers } from 'redux';

import site from './site';

export const getSite = state => getIn(state, [NAME, 'site'], SITES.com);

export const getSearchQuery = state =>
  getIn(state, ['router', 'location', 'search'], '');

export const getSearchQueryString = state => {
  const query = qs.parse(getSearchQuery(state), { ignoreQueryPrefix: true });
  return query.q || '';
};

export const getSearchQueryTopics = state => {
  const query = qs.parse(getSearchQuery(state), { ignoreQueryPrefix: true });
  return query.topics || '';
};

export const getSearchRegionQueryString = state => {
  const query = qs.parse(getSearchQuery(state), { ignoreQueryPrefix: true });
  return query.regions || '';
};

export const getPathname = state =>
  getIn(state, ['router', 'location', 'pathname'], '');

const getPressroomName = (list, id) => {
  const listArr = Object.keys(list)
    .map(key => list[key])
    .filter(n => n.attributes.pressroomId === id);
  return getIn(listArr, [0, 'attributes', 'pressroomName'], id);
};
const getCompanyNameByIdForNews = (state, id) => {
  let list = getIn(state, ['start', 'news', 'data'], {});
  return getPressroomName(list, id);
};
const getCompanyNameByIdForMaterials = (state, id) => {
  let list = getIn(state, ['search', 'materials', 'data'], {});
  return getPressroomName(list, id);
};
const getCompanyNameByIdForPressrooms = (state, id) => {
  const list = getIn(state, ['search', 'pressrooms', 'data'], {});
  return getIn(list, [id, 'attributes', 'name'], id);
};

export const getCompanyNameById = (state, id) => {
  switch (getPathname(state)) {
    case '/':
      return getCompanyNameByIdForNews(state, id);
    case '/stories':
      return getCompanyNameByIdForMaterials(state, id);
    case '/organisations':
      return getCompanyNameByIdForPressrooms(state, id);
    default:
      return id;
  }
};

export default combineReducers({
  site,
});
